module.exports = __webpack_public_path__ + "static/media/performing.b0dd7015.png";